import { useEffect } from 'react';

// Restore the previous document metadata when leaving the article experience.
export const useArticleMetadata = ({ title, description, path, image, notFound = false, isArticle = false }) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title} | Recrutement Suisse`;
    const url = new URL(path, process.env.REACT_APP_BACKEND_URL).href;
    const updates = [
      ['meta[name="title"]', 'content', document.title],
      ['meta[name="description"]', 'content', description],
      ['meta[name="robots"]', 'content', notFound ? 'noindex, follow' : 'index, follow'],
      ['meta[property="og:title"]', 'content', document.title],
      ['meta[property="og:description"]', 'content', description],
      ['meta[property="og:url"]', 'content', url],
      ['meta[property="og:type"]', 'content', isArticle ? 'article' : 'website'],
      ['meta[name="twitter:title"]', 'content', document.title],
      ['meta[name="twitter:description"]', 'content', description],
      ['meta[name="twitter:url"]', 'content', url],
      ['link[rel="canonical"]', 'href', url],
    ];
    if (image) updates.push(['meta[property="og:image"]', 'content', image], ['meta[name="twitter:image"]', 'content', image]);
    const restore = updates.map(([selector, attribute, value]) => {
      const element = document.querySelector(selector);
      if (!element) return () => {};
      const previous = element.getAttribute(attribute);
      element.setAttribute(attribute, value);
      return () => previous === null ? element.removeAttribute(attribute) : element.setAttribute(attribute, previous);
    });
    return () => {
      document.title = previousTitle;
      restore.forEach(reset => reset());
    };
  }, [title, description, path, image, notFound, isArticle]);
};